"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _get = _interopRequireDefault(require("lodash/get"));
var _has = _interopRequireDefault(require("lodash/has"));
var _BrixelIcon = _interopRequireDefault(require("./BrixelIcon"));
var _translation = _interopRequireDefault(require("../Translation/translation"));
var _reactRedux = require("react-redux");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const BrixelTabs = props => {
  const {
    activeTab = '',
    arrayComponents = null,
    arrayPanels = null,
    className = '',
    classNameArray = [],
    classNameIcon = '',
    classNameLabel = '',
    classNameLi = '',
    classNamePanels = '',
    classNameUl = '',
    clicksList = [],
    clicksListName = null,
    fullWidth = false,
    horzScroll = false,
    isSideMenu = false,
    labels = [],
    labelsIcons = [],
    labelsRight = [],
    lang = null,
    onClick = null,
    shortLabels = null,
    showFull = false,
    theme = null,
    translations,
    vertical = false
  } = props;
  const [activeID, setActiveID] = (0, _react.useState)(-1);
  const [activeIntTab, setActiveIntTab] = (0, _react.useState)(activeTab || (0, _get.default)(clicksListName, '[0]', null) || clicksList[0]);
  const [posY, setPosY] = (0, _react.useState)(0);
  const [posX, setPosX] = (0, _react.useState)(0);
  const [widthBorder, setWidthBorder] = (0, _react.useState)(0);
  const [heightBorder, setHeightBorder] = (0, _react.useState)(0);
  const [winWidth, setWinWidth] = (0, _react.useState)(0);
  const activeLi = (0, _react.useRef)(null);
  const singleLi = (0, _react.useRef)(null);
  const allTab = labels.concat(labelsRight);
  const horTabRef = (0, _react.useRef)(null);
  const horUlRef = (0, _react.useRef)(null);
  const onClickTab = (id, actTab) => {
    if (activeLi.current) setWidthBorder(activeLi.current.offsetWidth);
    if (activeLi.current) setHeightBorder(activeLi.current.offsetHeight);
    if (activeLi.current) setPosX(activeLi.current.offsetLeft);
    if (activeLi.current) setPosY(activeLi.current.offsetTop);
    setActiveID(id);
    setActiveIntTab(actTab);
    if (onClick) onClick(clicksList[id]);
  };
  (0, _react.useEffect)(() => {
    const tab = activeTab || (0, _get.default)(clicksListName, '[0]', null) || clicksList[0];
    setActiveIntTab(activeTab || (0, _get.default)(clicksListName, '[0]', null) || clicksList[0]);
    const id = clicksList.findIndex(val => val === tab);
    if (id > -1 && activeTab) setActiveID(id);
  }, [activeTab, clicksList]);
  (0, _react.useEffect)(() => {
    setTimeout(() => {
      if (activeLi.current) {
        setWidthBorder(activeLi.current.offsetWidth);
        setHeightBorder(activeLi.current.offsetHeight);
        setPosX(activeLi.current.offsetLeft);
        setPosY(activeLi.current.offsetTop);
      }
    }, 100);
  }, [(0, _get.default)(activeLi, 'current', null), (0, _get.default)(activeLi, 'current.offsetTop', null), (0, _get.default)(activeLi, 'current.offsetLeft', null), activeIntTab, activeTab, activeID]);
  (0, _react.useEffect)(() => {
    let winWidthEl = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    if (winWidthEl) setWinWidth(winWidthEl);
    window.addEventListener('resize', () => {
      winWidthEl = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      if (winWidthEl) setWinWidth(winWidthEl);
    });
  });
  let widthTab = 100 / allTab.length;
  let posHor = 100 / allTab.length * activeID;
  if (winWidth <= 768) {
    widthTab = allTab.length > 4 ? 22 : 100 / allTab.length;
    posHor = allTab.length > 4 ? 22 * activeID : 100 / allTab.length * activeID;
  }
  let height = '';
  let minWidth = '';
  let maxWidth = '';
  let left = '';
  let top = '';
  let transform = '';
  if (vertical) {
    height = fullWidth ? `${100 / allTab.length}%` : heightBorder / 2;
    top = fullWidth ? `${100 / allTab.length * activeID}%` : posY + heightBorder / 2;
    transform = fullWidth ? '' : 'translateY(-50%)';
  } else {
    minWidth = fullWidth ? `${widthTab}%` : widthBorder;
    maxWidth = fullWidth ? `${widthTab}%` : widthBorder;
    left = fullWidth ? `${posHor}%` : posX;
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `brixel-tabs ${className} ${fullWidth ? 'fullWidth' : ''} ${vertical ? 'verticalTabs' : 'horizontalTabs'} pos-r ${isSideMenu ? 'sidebarMenu' : ''} ${horzScroll ? 'horzScroll' : ''} ${theme}`,
    ref: vertical ? null : horTabRef
  }, !showFull && (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("ul", {
    className: `${vertical ? 'dis-fl-col' : 'dis-fl-row'} pos-r tabsList ${classNameUl} ${vertical ? '' : 'horTabList'}`,
    ref: vertical ? null : horUlRef
  }, !vertical && shortLabels ? (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, shortLabels.map((label, i) => (/*#__PURE__*/_react.default.createElement("li", {
    ref: activeIntTab === clicksList[i] || activeIntTab === (0, _get.default)(clicksListName, `[${i}]`, null) ? activeLi : singleLi,
    className: `${activeIntTab === clicksList[i] || activeIntTab === (0, _get.default)(clicksListName, `[${i}]`, null) ? 'active' : ''} ${classNameLi} ${!clicksList[i] ? 'disabled' : ''}`,
    key: `li_${i.toString()}`,
    onClick: () => clicksList[i] ? onClickTab(i, clicksList[i]) : '',
    style: {
      flex: fullWidth ? `0 0 ${widthTab}%` : '',
      minWidth: fullWidth ? `${widthTab}%` : '',
      maxWidth: fullWidth ? `${widthTab}%` : ''
    }
  }, labelsIcons[i] && (/*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
    iconSize: `${classNameIcon} txtText400 icnText400`,
    icon: labelsIcons[i]
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: `${classNameLabel} ${labelsIcons[i] ? 'txtText400 icnText400' : ''}`,
    dangerouslySetInnerHTML: {
      __html: lang ? (0, _translation.default)(label, lang, undefined, translations) : label
    }
  })))))) : (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, allTab.map((label, i) => (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
    key: `tab_${i.toString()}`
  }, i === labels.length && (/*#__PURE__*/_react.default.createElement("li", {
    className: "lineThrough mx-md-1 my-md-2"
  })), /*#__PURE__*/_react.default.createElement("li", {
    ref: activeIntTab === clicksList[i] || activeIntTab === (0, _get.default)(clicksListName, `[${i}]`, null) ? activeLi : singleLi,
    className: `listItem ${activeIntTab === clicksList[i] || activeIntTab === (0, _get.default)(clicksListName, `[${i}]`, null) ? 'active' : ''} ${labels[i] ? labels[i].toString().toLowerCase() : ''} ${classNameLi} ${i === labels.length ? 'right' : 'left'} ${allTab.length > 1 ? '' : 'ta-l'} ${!clicksList[i] ? 'disabled' : ''}`,
    onClick: () => clicksList[i] ? onClickTab(i, clicksList[i]) : '',
    style: {
      flex: fullWidth ? `0 0 ${widthTab}%` : '',
      minWidth: fullWidth ? `${widthTab}%` : '',
      maxWidth: fullWidth ? `${widthTab}%` : ''
    }
  }, labelsIcons[i] && (/*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
    iconSize: `${classNameIcon} txtText400 icnText400`,
    icon: labelsIcons[i]
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: `${classNameLabel} ${labelsIcons[i] ? 'txtText200' : ''}`,
    dangerouslySetInnerHTML: {
      __html: lang ? (0, _translation.default)(label, lang, undefined, translations) : label
    }
  }))))))), activeID > -1 && theme !== 'btnStyleTab' && (/*#__PURE__*/_react.default.createElement("li", {
    className: "activeBar zIndex1",
    style: {
      height,
      minWidth,
      maxWidth,
      left,
      top,
      transform
    }
  }))))), (arrayPanels || arrayComponents) && !showFull && (/*#__PURE__*/_react.default.createElement("div", {
    className: "panelTab"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "scrollTab",
    style: {
      width: `${100 * allTab.length}%`,
      transform: `translate(-${100 / allTab.length * activeID}%,0)`
    }
  }, arrayPanels && arrayPanels.map((panel, i) => (/*#__PURE__*/_react.default.createElement("div", {
    className: `${classNamePanels} ${classNameArray[i] || ''}`,
    key: `pnl_${i.toString()}`,
    style: {
      flex: `0 0 ${100 / labels.length}%`,
      width: `${100 / allTab.length}%`
    }
  }, Object.keys(panel).map((key, g) => (/*#__PURE__*/_react.default.createElement("div", {
    className: `panelsTab row-cols-2 dis-f ${classNamePanels}`,
    key: `pnlTab_${g.toString()}`
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "titleRow"
  }, lang ? (0, _translation.default)(key, lang, undefined, translations) : key)), /*#__PURE__*/_react.default.createElement("div", null, (0, _get.default)(panel[key], 'text', null) ? (/*#__PURE__*/_react.default.createElement("div", {
    className: "textRow",
    onClick: () => (0, _get.default)(panel[key], 'func', null) ? panel[key].func() : '',
    dangerouslySetInnerHTML: {
      __html: lang ? (0, _translation.default)(panel[key].text, lang, undefined, translations) : panel[key].text
    }
  })) : (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, panel[key] && (panel[key].component || /*#__PURE__*/_react.default.isValidElement(panel[key])) ? (/*#__PURE__*/_react.default.createElement((0, _has.default)(panel[key], 'component') ? panel[key].component : panel[key].type, panel[key].props)) : (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, panel[key] ? (/*#__PURE__*/_react.default.createElement("div", {
    className: "textRow",
    dangerouslySetInnerHTML: {
      __html: lang ? (0, _translation.default)(panel[key].toString(), lang, undefined, translations) : panel[key].toString()
    }
  })) : (/*#__PURE__*/_react.default.createElement("div", {
    className: "textRow"
  }, "-"))))))))))))), arrayComponents && arrayComponents.map((panel, i) => (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, typeof panel !== 'object' && (/*#__PURE__*/_react.default.createElement("div", {
    className: `${classNamePanels} ${classNameArray[i] || ''}`,
    key: `cmp_${i.toString()}`,
    style: {
      flex: `0 0 ${100 / allTab.length}%`,
      width: `${100 / allTab.length}%`
    }
  }, panel)))))))), (arrayPanels || arrayComponents) && showFull && (/*#__PURE__*/_react.default.createElement("div", {
    className: "panelTab"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "scrollTab",
    style: {
      width: '100%'
    }
  }, arrayPanels && arrayPanels.map((panel, i) => (/*#__PURE__*/_react.default.createElement("div", {
    className: `${classNamePanels} ${classNameArray[i] || ''}`,
    key: `arr_${i.toString()}`,
    style: {
      flex: `0 0 ${100 / allTab.length}%`,
      width: `${100 / allTab.length}%`
    }
  }, Object.keys(panel).map((key, g) => (/*#__PURE__*/_react.default.createElement("div", {
    className: `panelsTab row-cols-2 dis-f ${classNamePanels}`,
    key: `arrPnl_${g.toString()}`
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "titleRow"
  }, lang ? (0, _translation.default)(key, lang, undefined, translations) : key)), /*#__PURE__*/_react.default.createElement("div", null, panel[key] ? (/*#__PURE__*/_react.default.createElement("div", {
    className: "textRow",
    dangerouslySetInnerHTML: {
      __html: lang ? (0, _translation.default)(panel[key].toString(), lang, undefined, translations) : panel[key].toString()
    }
  })) : (/*#__PURE__*/_react.default.createElement("div", {
    className: "textRow"
  }, "-"))))))))), arrayComponents && arrayComponents.map((panel, i) => (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, typeof panel !== 'object' && (/*#__PURE__*/_react.default.createElement("div", {
    className: `${classNamePanels} ${classNameArray[i] || ''}`,
    key: `arrCmp_${i.toString()}`,
    style: {
      flex: `0 0 ${100 / allTab.length}%`,
      width: `${100 / allTab.length}%`
    }
  }, panel)))))))));
};
const mapStateToProps = state => ({
  translations: (0, _get.default)(state, 'translations', {})
});
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(BrixelTabs);